import React from 'react'

import { ThemeProvider } from '@leshen/ui'
import GlobalStyles from './CustomStyles/GlobalStyles'

const Wrapper = ({ children, customTheme }) => (
  <ThemeProvider theme={customTheme}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
)

Wrapper.defaultProps = {
  theme: {},
}

export default Wrapper
